// extracted by mini-css-extract-plugin
module.exports = {"slidePage":"slidePage--3RrmI","open":"open--jHLJ3","header":"header--3NAor","goBack":"goBack--3_l8-","title":"title--1462U"};